module.exports = __webpack_public_path__ + "img/logo.c56e7c5a.png";